/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.roles.list.controllers', [
  'ui.router',
  'ui.bootstrap',
  'ui.grid',
  'acme.common.service.api',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.view.application.roles.createModal.controllers',
  'acme.view.application.roles.removeModal.controllers',
  'acme.common.factory.gridState'
])

.controller('RolesListController', ['$scope', '$state', '$uibModal', '$timeout', 'ApiService', 'PermissionsService', 'NoticeFactory', 'GridStateFactory', function($scope, $state, $uibModal, $timeout, ApiService, PermissionsService, NoticeFactory, GridStateFactory) {

    $scope.rolesList = {

      model: [],
      addModal: {},
      isLoaded: false,

      notice: new NoticeFactory(),

      gridState: new GridStateFactory(),

      grid: {
        pageSize: 50,
        showFooter: true,
        paginate: true,
        multiselect: false,
        enableRowSelection: false,
        useExternalPagination: true,
        useExternalSorting: true,
        columns: [
          {
            field: 'name',
            displayName: 'Role'
          }
        ]
      },

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Manage Roles',
          buttonRight: {
            label: 'Add Role',
            permissions: 'ROLES_CREATE',
            action: function() {
              $scope.rolesList.create();
            }
          }
        });

        if (PermissionsService.check('ROLES_UPDATE')) {
          this.grid.columns.push({
            field: 'active',
            displayName: 'Active',
            onCellNavClick: function(row, col) {
              $scope.rolesList.edit(row);
            },
            enableHiding: false,
            enableSorting: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.edit(row)"><span data-ng-if="row.entity.active">Yes</span><span data-ng-if="!row.entity.active">No</span></a></div>'
          });
        }

        this.gridState.updateGridState(null, this.grid.pageSize, 'name', 'asc');

        this.getRoles();

      },

      getRoles: function() {
        ApiService.roles.list(this.gridState.getGridState()).then(this.success.init, this.error.init);
      },

      findRole: function(id) {

        var i, ii,
          r = false;

        for (i=0,ii=this.model.length;i<ii;i++) {
          if (this.model[i].id === id) {
            r = {
              role: this.model[i],
              index: i
            };
          }
        }

        return r;

      },

      create: function(response) {

        var self = $scope.rolesList;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/roles/modals/createRole.tpl.html',
          size: 'lg',
          controller: 'RolesCreateModalController',
          resolve: {
            roles: function() {
              return self.model;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (role) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          ApiService.roles.create(role).then(self.success.create, self.error.create);
        }, function () {
          // Do nothing
        });

      },

      remove: function(id) {
        var self = $scope.rolesList,
          found = self.findRole(id);

        self.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/roles/modals/removeRole.tpl.html',
          size: 'md',
          controller: 'GroupsRolesRemoveModalController',
          resolve: {
            currentRole: function() {
              return found.role;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.removeModal.result.then(function () {
          ApiService.roles.remove(found.role.id).then(function(response, status, headers, config) {
            self.model.splice(found.index, 1);
            self.success.remove(response, status, headers, config);
          }, function(response, status, headers, config) {
            self.error.remove(response, status, headers, config);
          });
        }, function () {
          // Do nothing
        });
      },

      edit: function(row) {
        var self = $scope.rolesList;

        row.entity.active = !row.entity.active;
        ApiService.roles.update(row.entity).then(self.success.edit, self.error.edit);
      },

      success: {
        init: function(response) {
          var self = $scope.rolesList;
          //next tick
          $timeout(function() {
            self.model = response.data.payload.list;
            self.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
          }, 0);
          self.isLoaded = true;
        },
        remove: function(response) {},
        create: function(response) {
          var self = $scope.rolesList;
          self.model.push(response.data.payload);
        },
        update: function(response) {}
      },

      error: {
        init: function(response) {},
        remove: function(response) {},
        create: function(response) {
          var self = $scope.rolesList;
          self.notice.showErrorMessages([
            { message: response.data.error }
          ]);
        },
        update: function(response) {
          var self = $scope.rolesList;
          self.notice.showErrorMessages([
            { message: response.data.error }
          ]);
        }
      },

      gridDoubleClick: function(row) {
        console.log('RolesListController::gridDoubleClick', row);
        $state.go('application.roles.permissions', { id: row.entity.id });
      },

      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.rolesList;
        self.gridState.updateGridState(newPage, pageSize);
        self.getRoles();
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.rolesList, data = columns[0];
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getRoles();
        }
      }

    };

    $scope.rolesList.init();

}]);